export default "__VITE_ASSET__BoOLbxFV__"